import { AccountType } from '@/autogenerated/@prisma/prisma-mongo-client';

export type MenuPublicItemType = {
  title: string;
  link: string;
};

export const getStaticMenuItems = (): MenuPublicItemType[] => {
  return [
    {
      title: 'homePublic',
      link: 'https://www.findhaven.org',
    },
    {
      title: 'languageProgram',
      link: 'https://www.findhaven.org/language-refugees',
    },
    {
      title: 'howToHelp',
      link: 'https://www.findhaven.org/language',
    },
    {
      title: 'safety',
      link: 'https://www.findhaven.org/safety',
    },
    {
      title: 'about',
      link: 'https://www.findhaven.org/about',
    },
  ];
};

export const getAuthMenuItems = (
  isLoggedIn: boolean,
  userTypeQueryParam?: AccountType
): MenuPublicItemType[] => {
  if (isLoggedIn) {
    return [
      {
        title: 'logout',
        link: '/logout',
      },
    ];
  } else {
    return [
      {
        title: 'login',
        link: '/login',
      },
      {
        title: 'signup',
        link: `/signup?usertype=${userTypeQueryParam?.toLocaleLowerCase()}`,
      },
    ];
  }
};
